module.exports = __webpack_public_path__ + "img/uz.927b7648.svg";